<template>
  <logo-layout 
    :title="$t('pages.login.reestablecer')" 
    :description="$t('pages.login.reestablecerTexto')"
  >
    <v-layout justify-center>
      <v-flex xs12 sm8 md6 lg5 xl3>
        <v-card>
          <v-container fluid>
            <v-form v-model="valid">
              <v-text-field
                v-model="usermail"
                :name="usermail"
                :rules="[rules.required, rules.email, rules.max(100)]"
                :label="$t('incrustado.email')"
                required
              ></v-text-field>
              <v-layout justify-center mt-3>
                <v-btn :disabled="!valid || desactivarBoton" :loading="desactivarBoton" color="primary" @click="resetPassword()">
                  {{$t('pages.login.reestablecer')}}
                </v-btn>
              </v-layout>
            </v-form>
            <v-layout row justify-start>
              <v-btn 
                class="titleColor--text pl-0 ml-0"
                @click="$router.push({name: 'login'})"
                flat
              >
                <v-icon class="titleColor--text">navigate_before</v-icon> {{$t('general.misc.volver')}}
              </v-btn>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </logo-layout>
</template>

<script>
import rulesMixin from '@/mixins/rules.js'
import { mapActions } from 'vuex'
export default {
  mixins: [rulesMixin],
  data () {
    return {
      usermail: '',
      valid: false,
      desactivarBoton: false
    }
  },
  methods: {
    ...mapActions({
      resetPasswordApi: 'login/resetPassword',
      addAlert: 'alerts/add'
    }),
    async resetPassword () {
      this.desactivarBoton = true
      try {
        await this.resetPasswordApi(this.usermail)
        this.addAlert({texto: this.$t('pages.login.recibiraContrasena'), color: 'success'})
        this.$router.push({
          name: 'login'
        })
        this.desactivarBoton = false
      } catch (error) {
        this.desactivarBoton = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/login/resetPassword.vue